import { render, staticRenderFns } from "./ViewComponentes.vue?vue&type=template&id=8f5b6228&"
import script from "./ViewComponentes.vue?vue&type=script&lang=js&"
export * from "./ViewComponentes.vue?vue&type=script&lang=js&"
import style0 from "./ViewComponentes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports